import { useTranslation } from "next-i18next";

function LoadIndex(props: any) {
  const { t } = useTranslation("category-map");
  return `${props.loadIndex} = ${props.loadIndexKgPerTire}/${t("tire")}`;
}

function SpeedRating(props: any) {
  return `${props.speedRating}- ${props.speedRatingKmPerHour}`;
}

export function TireSize(props: any) {
  return (
    <span>
      {`${props.widthInMm} / ${props.profile} ${props.construction}${props.diameterInInches}`}
    </span>
  );
}

export function WheelOffset(props: any) {
  return `${props.offset}mm`;
}

const UI_VALUE = {
  loadIndex: <LoadIndex />,
  speedRating: <SpeedRating />,
  widthInMm: <TireSize />,
  offset: <WheelOffset />,
};

export default UI_VALUE;
